import type { Tourflow } from '@aviata/platform-types';

export enum RequestSource {
  Main = 'main_page',
  HotelDetails = 'hotel_details_page',
  EmptyResults = 'empty_results_page',
}

export type UserData = Tourflow.Request.UserData;

export type TourData = Tourflow.Request.TourData;

export type RequestPayload = Tourflow.Request.Payload;
